import * as authFlags from 'context/AuthContext/statusFlags';

export function enableLogout(authState:string) {
  return (
    authState === authFlags.AUTHORISE_EMPLOYEE_ERROR  
      || authState === authFlags.AUTHORISE_EMPLOYEE_RETURN_ERROR
      || authState === authFlags.AUTHORISE_EMPLOYEE_INACTIVE
      || authState === authFlags.POST_USER_TOKEN_ERROR
  );
}

export function setLoading(authState:string) {
  return (
    authState === authFlags.GOOGLE_LOGIN
      || authState === authFlags.POST_USER_TOKEN
      || authState === authFlags.AUTHORISE_EMPLOYEE
      || authState === authFlags.AUTHORISE_EMPLOYEE_RETURN
  );
}

export function setAuthError(authState: string) {
  let errorMessage;
  switch (authState) {
    case authFlags.GOOGLE_LOGIN_ERROR:
      errorMessage = 'Google Login Error'
      break;
    case authFlags.POST_USER_TOKEN_ERROR:
    case authFlags.AUTHORISE_EMPLOYEE_ERROR:
    case authFlags.AUTHORISE_EMPLOYEE_RETURN_ERROR:
      errorMessage = 'Error Logging Into User Service'
      break;
    case authFlags.AUTHORISE_EMPLOYEE_INACTIVE:
      errorMessage = 'Unable to Log In, Inactive Account'
      break;
    default:
      errorMessage = '';
  }
  return errorMessage;
}